import React, { Component } from 'react';
import ListOfCustomAttributes from '../../components/custom-attributes/ListOfCustomAttributes';
import OrganisationName from '../../components/shared/OrganisationName';
import SetTitle from '../../components/shared/SetTitle';
import PopupBox from '../../components/shared/PopupBox';

class CustomAttributesIndex extends Component {
  render() {
    const { match: { params } } = this.props;

    return (
      <div>
        <SetTitle title={"Custom Attributes"} />
        <PopupBox />

        <h2 className="page-title">Custom Attributes</h2>
        <OrganisationName />

        <div>
          <ListOfCustomAttributes id={params.id} />
        </div>
      </div>
    );
  }
}

export default CustomAttributesIndex;
